<template>
    <div class="serve ">
        <!-- <div class="way">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                  
                    <breadcrumb></breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <div class="main">
            <el-row type="flex"
                    class="row-bg primary"
                    justify="center">
                <el-col :span="20"
                        class="equipartition">
                    <div class="btn"
                         v-show="index<6"
                         v-for="(item,index) in brotherMenu"
                         :key="index"
                         @click="assign(item)"
                         :class="{active: activeIndex === item.id}">
                        <p class="line">{{item.name}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <keep-alive>
            <component :is="currentpage"></component>
        </keep-alive>
    </div>
</template>

<script>
// import Bus from "@/utils/bus";
import collecting from "@/views/service/collecting";
import transportation from "@/views/service/transportation";
import receipt from "@/views/service/receipt";
import packaging from "@/views/service/packaging";
import provide from "@/views/service/provide";
import message from "@/views/service/message";
import breadcrumb from "@/components/breadcrumb";
import { mapGetters } from "vuex";
export default {
    components: {
        collecting,
        transportation,
        receipt,
        packaging,
        provide,
        message,
        breadcrumb
    },
    data() {
        return {
            position: "",
            currentpage: "collecting",
            list: [
                { name: "collecting", title: "待收货款" },
                { name: "transportation", title: "保价运输" },
                { name: "receipt", title: "回单签收" },
                { name: "provide", title: "送货上门" },
                { name: "packaging", title: "安全包装" },
                { name: "message", title: "短信服务" }
            ]
        };
    },
    computed: {
        ...mapGetters(["activeIndex", "parentList", "brotherMenu"])
    },
    mounted() {
        if (sessionStorage.getItem("activeIndex")) {
            this.$store.dispatch(
                "BannerPath",
                sessionStorage.getItem("activeIndex")
            );
        }
    },
    watch: {
        //监听路由变化
        $route(to, from) {
            this.currentpage = this.$route.params.id;
            this.search();
        }
    },
    created() {
        this.search();
        this.currentpage = this.$route.params.id;
    },
    methods: {
        search() {
            switch (this.$route.params.id) {
                case "collecting":
                    this.position = "待收货款";
                    break;
                case "transportation":
                    this.position = "保价运输";
                    break;
                case "receipt":
                    this.position = "回单签收";
                    break;
                case "packaging":
                    this.position = "安全包装";
                    break;
                case "provide":
                    this.position = "整车业务";
                    break;
                case "message":
                    this.position = "短信服务";
                    break;
            }
        },
        assign(item) {
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.id
                }
            });
            this.$store.dispatch("BannerPath", item.id);
            // this.$store.dispatch("UpdateActive", item);
            this.$store.dispatch("ProductdescById", item.id);
        }
    }
};
</script>

<style scoped lang="scss">
.serve {
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        .el-breadcrumb {
            line-height: 50px;
        }
    }
    .main {
        background-color: #fff;
        .primary {
            .equipartition {
                display: flex;
                .btn {
                    flex: 1;
                    cursor: pointer;
                    height: 54px;
                    margin: 0 auto;
                    display: inline-block;
                    text-align: center;
                    font-size: 20px;
                    line-height: 54px;
                }
            }
        }
    }
    .active {
        border-bottom: 2px solid #fabe00;
    }
}
</style>
